import React from 'react'
import { useIntl } from 'react-intl'
import { Pressable } from 'react-native'

import { useTheme } from 'styled-components/native'

import { AuroraIconCircle } from '../../organisms/lightHomeToolbar/utils'
import { ThemeType } from '../../utils/themes/ThemeProvider'
import { tID } from '../../utils/utils'
import { ButtonSize } from '../baseButton/BaseButton'
import { ClientMessagingAiIcon } from '../icons/ClientMessagingAiIcon'
import { ClientMessagingIcon } from '../icons/ClientMessagingIcon'
import { ClientMessagingUnreadIcon } from '../icons/ClientMessagingUnreadIcon'
import TertiaryIconButton from '../tertiaryIconButton/TertiaryIconButton'

interface HeaderMessagingIconProps {
  showGenAi?: boolean
  showUnread?: boolean
  onPress?: () => void
  isExpanded?: boolean
  testID?: string
  hitSlop?: number
}

export const HeaderMessagingIcon: React.FC<HeaderMessagingIconProps> = ({
  showGenAi,
  showUnread,
  onPress,
  isExpanded = false,
  testID = 'MessageIcon',
  hitSlop,
}) => {
  const { isAuroraTheme } = useTheme() as ThemeType
  const { formatMessage } = useIntl()

  const getIcon = () => {
    return showGenAi ? <ClientMessagingAiIcon /> : showUnread ? <ClientMessagingUnreadIcon /> : <ClientMessagingIcon />
  }

  if (isAuroraTheme) {
    return (
      <TertiaryIconButton
        testID={testID}
        size={ButtonSize.SMALL}
        style={{ padding: 0 }}
        leftIcon={<AuroraIconCircle>{getIcon()}</AuroraIconCircle>}
        onPress={onPress ? onPress : () => {}}
        hitSlop={hitSlop}
        accessibilityLabel={formatMessage({
          defaultMessage: 'Messenger',
          description: 'Accessibility label for messenger icon button',
        })}
      />
    )
  }

  return (
    <Pressable
      testID={tID(testID)}
      role='button'
      aria-label={formatMessage({
        defaultMessage: `Messenger`,
        description: 'Messaging icon button that can display a badge to indicate unread messages',
      })}
      aria-expanded={isExpanded}
      onPress={onPress}
      accessible
      accessibilityRole='button'
      hitSlop={hitSlop}
    >
      {getIcon()}
    </Pressable>
  )
}
